
import { defineComponent, PropType } from 'vue'

// Composables
import { useDashboardManager } from '@/metrics/use-dashboards'

// Misc
import { Dashboard } from '@/metrics/types'

export default defineComponent({
  name: 'DashPinBtn',

  props: {
    dashboard: {
      type: Object as PropType<Dashboard>,
      required: true,
    },
  },

  setup(props, ctx) {
    const dashMan = useDashboardManager()

    function pinDashboard() {
      dashMan.pin(props.dashboard).then((dash) => {
        ctx.emit('update', dash)
      })
    }

    function unpinDashboard() {
      dashMan.unpin(props.dashboard).then((dash) => {
        ctx.emit('update', dash)
      })
    }

    return {
      dashMan,

      pinDashboard,
      unpinDashboard,
    }
  },
})
